import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
export const trainDropWatchTimePredictionEndpoint = {
    [dropEndpointIds.TRAIN_DROP_WATCH_TIME_PREDICTION]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
